import { render, staticRenderFns } from "./ClientInventoryList.vue?vue&type=template&id=07588427&"
import script from "./ClientInventoryList.vue?vue&type=script&lang=ts&"
export * from "./ClientInventoryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports